import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {EtlDesignDTO} from '@tj/tj-dmp-lib-api';
import {FieldMapping} from '../field-mapping.interface';
import {TargetFieldDestination} from '../target-field-destination.interface';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'dmp-etl-popup-design-static-param',
    templateUrl: './etl-popup-design-static-param.component.html',
    styleUrls: ['./etl-popup-design-static-param.component.scss'],
    standalone: false
})
export class EtlPopupDesignStaticParamComponent implements OnChanges {

  @Input() public field: TargetFieldDestination;
  @Input() public tenant: string;
  @Input() public etl: EtlDesignDTO;
  @Input() public isAuthorisedAdmin: boolean = false;

  @Output() public closePopup = new EventEmitter<null>();
  @Output() public modif = new EventEmitter<TargetFieldDestination[]>();

  displayParamField = false;

  validate = false;

  isNew = false;


  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update() {
    this.displayParamField = this.field != null;
    this.isNew = this.field?.fieldDest === null;
  }

  onHideDialogParamField(event): void {
    this.closePopup.emit();
  }
  onShowDialogParamField(event): void {
    this.updateValidate();
  }

  doCancel(): void {
    this.closePopup.emit();
  }

  doValidateAndClose(): void {
    this.modif.emit([this.field]);
    this.closePopup.emit();
  }

  updateValidate(): void {
    this.validate = this.field.fieldDest &&
      this.field.tableDest &&
      this.field.value && this.field.value.trim().length > 0;
  }

  updateMappingForAddField(mapping: FieldMapping) {
    this.field.fieldDest = mapping.fieldDest;
    this.field.tableDest = mapping.tableDest;
    this.field.meta = mapping.field;
    this.updateValidate();
  }


}
